export const getFitBounds = (state) => state.map.fitBounds;
export const getFitBoundsOptions = (state) => state.map.fitBoundsOptions;
export const zoomSelector = (state) => state.map.zoom;
export const zoomLevelSelector = (state) => state.map.zoomLevel;
export const targetZoomLevelSelector = (state) => state.map.targetZoomLevel;
export const receivedUserInputSelector = (state) => state.map.receivedUserInput;
export const visiblePostcodes = (state) => [
  ...new Set(state.map.visiblePostcodes),
];
export const centerPointSelector = (state) => state.map.centerPoint;
export const jumpToSelector = (state) => state.map.jumpTo;
export const isZoomingSelector = (state) => state.map.isZooming;
export const streetViewSelector = (state) => state.map.streetView;
export const popupDetailsSelector = (state) => state.map.popupDetails;
export const lastPopupDetailsSelector = (state) => state.map.lastPopupDetails;
export const artificialFeaturesSelector = (state) =>
  state.map.artificialFeatures;
